import {
    GeneralSettingContract,
    OperationalSettingContract,
    CurrencyContract,
    ClosingProceduresContract,
    MenuConfigurationContract,
    CountryContract,
} from 'models'
import repository from 'Services/api/operation-setting.service'
import { repository as currency } from 'Services/api/currency.service'
import companyApi from 'Services/api/company.service'
import locationAPI from 'Services/api/location.service'
import { createDispatchActionSet, fetchWithNotification } from './base.action'
export interface OperationalSettingOtherSetting
    extends OperationalSettingContract {
    logo?: string
    currentCountry?: CountryContract
}

export const getOperationSettingActions = createDispatchActionSet<
    OperationalSettingOtherSetting
>('OPERATION_GET')
export const getCompanyLogoActions = createDispatchActionSet<string>(
    'OPERATION_GET_LOGO',
)
export const updateOperationSettingActions = createDispatchActionSet<
    OperationalSettingContract
>('OPERATION_UPDATE')
export const getCurrencyActions = createDispatchActionSet<CurrencyContract[]>(
    'OPERATION_GET_CURRENCY',
)
export const updateGeneralSettingActions = createDispatchActionSet<
    GeneralSettingContract
>('OPERATION_UPDATE_GENERAL_SETTING')
export const updateTimeClockModuleSettingActions = createDispatchActionSet<
    boolean
>('OPERATION_UPDATE_TIMECLOCK_MODULE_SETTING')
export const updateClosingProcedureSettingActions = createDispatchActionSet<
    ClosingProceduresContract
>('UPDATE_CLOSING_PROCEDURE_SETTING')
export const updateMenuConfigurationActions = createDispatchActionSet<
    MenuConfigurationContract
>('OPERATION_UPDATE_MENU_CONFIGURATION')
export const updateGeneralPOSTerminalActions = createDispatchActionSet<
    MenuConfigurationContract
>('OPERATION_UPDATE_POS_TERMINAL_USER_IDLE_TIMEOUT')

export const UPDATE_KITCHEN_CATEGORY_SORT_ORDER =
    'UPDATE_KITCHEN_CATEGORY_SORT_ORDER'

export const getCompanyInfoAndSetting = () => async (dispatch: any) => {
    try {
        dispatch(getOperationSettingActions.pending())
        const [operationRes, logoRes, countryRes] = await fetchWithNotification(
            {
                apiLinkFnc: () =>
                    Promise.all([
                        repository.getOperationSetting(),
                        companyApi.getCompanyLogo(),
                        locationAPI.getCurrentUserCountry(),
                    ]),
            },
        )
        var setting: OperationalSettingOtherSetting = {
            ...(operationRes.data as OperationalSettingContract),
            logo: logoRes.data as string,
            currentCountry: countryRes.data,
        }
        dispatch(getOperationSettingActions.success(setting))
    } catch (err) {
        dispatch(getOperationSettingActions.failed(err))
    }
}
export const getCompanyLogo = () => async (dispatch: any) => {
    try {
        dispatch(getCompanyLogoActions.pending())
        const res = await companyApi.getCompanyLogo()
        dispatch(getCompanyLogoActions.success(res.data))
    } catch (err) {
        dispatch(getCompanyLogoActions.failed(err))
    }
}
export const updateOperationSetting = async (
    body: OperationalSettingContract,
    forceReload: boolean,
    dispatch: any,
) => {
    try {
        dispatch(updateOperationSettingActions.pending())
        console.log(body)
        await fetchWithNotification({
            apiLinkFnc: () =>
                repository.updateOperationSetting(body, forceReload),
            successMessage: 'Operation setting was successfully updated.',
        })
        dispatch(updateOperationSettingActions.success(body))
    } catch (err) {
        console.log(err)

        dispatch(updateOperationSettingActions.failed(err))
    }
}
export const updateMenuConfiguration = (
    body: MenuConfigurationContract,
) => async (dispatch: any) => {
    try {
        dispatch(updateMenuConfigurationActions.pending())
        await fetchWithNotification({
            apiLinkFnc: () => repository.updateMenuConfiguration(body),
            successMessage: 'Menu configuration was successfully updated.',
        })
        dispatch(updateMenuConfigurationActions.success(body))
    } catch (err) {
        dispatch(updateMenuConfigurationActions.failed(err))
    }
}
export const getCurrency = async (dispatch: any) => {
    try {
        dispatch(getCurrencyActions.pending())
        const res = await currency.getCurrencies()
        dispatch(getCurrencyActions.success(res.data))
    } catch (err) {
        dispatch(getCurrencyActions.failed(err))
    }
}
export const updateTimeClockGeneralSetting = (timeClock: boolean) => async (
    dispatch: any,
) => {
    dispatch(updateTimeClockModuleSettingActions.success(timeClock))
}
export const updateGeneralSetting = (
    payload: GeneralSettingContract,
    forceReload: boolean = false,
) => async (dispatch: any) => {
    try {
        dispatch(updateGeneralSettingActions.pending())
        await fetchWithNotification({
            apiLinkFnc: () =>
                repository.updateGeneralSetting(payload, forceReload),
            successMessage: 'General setting was successfully updated.',
        })
        dispatch(updateGeneralSettingActions.success(payload))
        return true
    } catch (err) {
        dispatch(updateGeneralSettingActions.failed(err))
        throw err
    }
}

export const updateClosingProcedureSetting = (
    payload: ClosingProceduresContract,
) => async (dispatch: any) => {
    try {
        dispatch(updateClosingProcedureSettingActions.pending)
        await fetchWithNotification({
            apiLinkFnc: () => repository.updateClosingProcedureSetting(payload),
            successMessage:
                'Closing procedure setting was successfully updated.',
        })
        dispatch(updateClosingProcedureSettingActions.success(payload))
    } catch (err) {
        dispatch(updateClosingProcedureSettingActions.failed(err))
        throw err
    }
}

export const updateOperationalSettingChanged = (
    operationalSetting: OperationalSettingContract,
) => (dispatch: any) => {
    dispatch(updateGeneralSettingActions.success(operationalSetting))
}
